module.exports = __webpack_public_path__ + "static/media/vehicle_orange.3c6fbf66.svg";